import { useNavigate } from "react-router-dom";
import logo from '../assets/bharat.png';

export default function Footer() {
	const navigate = useNavigate();
	const routeMap = {
		"Home": "/", "Store": "/store",
		"About Us": "/about", "Contact Us": "/contact",
		"E-mail Updates": "/register-mail-update", "My Account": "/account"
	};

	return (
		<footer 
			className="footer-main"
			style={{
				background: "linear-gradient(160deg, #1a0505 0%, #2C0A0A 60%, #1a0505 100%)",
				color: "rgba(255,255,255,0.6)",
				padding: "56px 72px 32px",
				position: "relative", overflow: "hidden"
			}}
		>
			<style>{`
				@media (max-width: 1024px) {
					.footer-main { padding: 40px 24px 24px !important; }
					.footer-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
					.footer-bottom { flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
				}
			`}</style>
			{/* Decorative red glow */}
			<div style={{
				position: "absolute", top: 0, left: "30%",
				width: 400, height: 200,
				background: "radial-gradient(ellipse, rgba(192,57,43,0.12) 0%, transparent 70%)",
				pointerEvents: "none"
			}} />
			{/* Subtle top border accent */}
			<div style={{
				position: "absolute", top: 0, left: 0, right: 0, height: 3,
				background: "linear-gradient(90deg, transparent, #C0392B 30%, #E8523A 50%, #C0392B 70%, transparent)"
			}} />

			<div className="footer-grid" style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr 1.5fr", gap: 48, marginBottom: 48, position: "relative", zIndex: 1 }}>

				{/* Brand column */}
				<div>
				<div
                style={{ display: "flex", alignItems: "center", gap: 10, }}
                
            >
                <div style={{
                    width: 144, height: 36, borderRadius: 10,
                    background: "transparent",
                    display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                    <img src={logo} alt="logo" />
                </div>
            </div>

					<div style={{ display: "flex", gap: 10, marginTop: 18 }}>
						{["📘", "🐦", "📸", "▶️"].map(icon => (
							<div
								key={icon}
								style={{
									width: 36, height: 36, borderRadius: 10,
									background: "rgba(255,255,255,0.05)",
									border: "1px solid rgba(192,57,43,0.25)",
									display: "flex", alignItems: "center", justifyContent: "center",
									fontSize: 16, cursor: "pointer", transition: "all 0.2s"
								}}
								onMouseEnter={e => { e.currentTarget.style.background = "rgba(192,57,43,0.25)"; e.currentTarget.style.borderColor = "#C0392B"; }}
								onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.05)"; e.currentTarget.style.borderColor = "rgba(192,57,43,0.25)"; }}
							>{icon}</div>
						))}
					</div>
				</div>

				{/* Quick links */}
				<div>
					<div style={{
						color: "white", fontWeight: 700, fontSize: 13, marginBottom: 18,
						letterSpacing: "0.08em", textTransform: "uppercase",
						display: "flex", alignItems: "center", gap: 8
					}}>
						<span style={{ width: 18, height: 2, background: "#C0392B", display: "inline-block", borderRadius: 2 }} />
						Quick Links
					</div>
					{Object.keys(routeMap).map(l => (
						<div
							key={l}
							onClick={() => { navigate(routeMap[l]); window.scrollTo(0, 0); }}
							style={{ fontSize: 13, marginBottom: 11, cursor: "pointer", transition: "all 0.2s", display: "flex", alignItems: "center", gap: 7 }}
							onMouseEnter={e => { e.currentTarget.style.color = "#E8523A"; e.currentTarget.style.paddingLeft = "4px"; }}
							onMouseLeave={e => { e.currentTarget.style.color = "rgba(255,255,255,0.6)"; e.currentTarget.style.paddingLeft = "0"; }}
						>
							<span style={{ width: 4, height: 4, borderRadius: "50%", background: "rgba(192,57,43,0.6)", flexShrink: 0 }} />
							{l}
						</div>
					))}
				</div>

				{/* Contact */}
				<div>
					<div style={{
						color: "white", fontWeight: 700, fontSize: 13, marginBottom: 18,
						letterSpacing: "0.08em", textTransform: "uppercase",
						display: "flex", alignItems: "center", gap: 8
					}}>
						<span style={{ width: 18, height: 2, background: "#C0392B", display: "inline-block", borderRadius: 2 }} />
						Contact
					</div>
					<div style={{ fontSize: 13, lineHeight: 1.9, color: "rgba(255,255,255,0.6)" }}>
						<strong style={{ color: "rgba(255,200,200,0.9)", fontSize: 12, letterSpacing: "0.04em" }}>BHARAT LAW HOUSE PVT. LTD.</strong><br />
						T-1/95, Mangolpuri Industrial Area, Phase-I<br />
						New Delhi-110 083<br />
						<div style={{ height: 10 }} />
						<span style={{ color: "rgba(255,200,200,0.7)", fontWeight: 600 }}>Phones:</span> 2791 0001-03<br />
						<span style={{ color: "rgba(255,200,200,0.7)", fontWeight: 600 }}>Mobile:</span> 98102 67553<br />
						<span style={{ color: "rgba(255,200,200,0.7)", fontWeight: 600 }}>E-mail:</span> sales@bharatlaws.com<br />
						<span style={{ color: "rgba(255,200,200,0.7)", fontWeight: 600 }}>Compliance:</span> ca.dbco@gmail.com
					</div>
				</div>
			</div>

			{/* Bottom bar */}
			<div 
				className="footer-bottom"
				style={{
				borderTop: "1px solid rgba(192,57,43,0.2)", paddingTop: 24,
				display: "flex", justifyContent: "space-between", alignItems: "center",
				flexWrap: "wrap", gap: 12, position: "relative", zIndex: 1
			}}>
				<span style={{ fontSize: 12 }}>© 2025 Bharat Law House Pvt. Ltd. All rights reserved.</span>
				<div style={{ display: "flex", gap: 20 }}>
					{["Privacy Policy", "Terms of Service", "Sitemap"].map(l => (
						<span
							key={l}
							style={{ fontSize: 12, cursor: "pointer", transition: "color 0.2s" }}
							onMouseEnter={e => e.currentTarget.style.color = "#E8523A"}
							onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.6)"}
						>{l}</span>
					))}
				</div>
				<span style={{ fontSize: 12 }}>Made with ❤️ in India 🇮🇳</span>
			</div>
		</footer>
	);
}